import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../../themes/palette";
import aboutusImg from "../../../assets/images/Aboutus/boris-misevic-HofOYDPOIdA-unsplash.jpg";
const useStyles = makeStyles((theme) => {
  return {
    mainAboutusContainer: {
      paddingLeft: theme.spacing(myTheme.padding.left + 3.4),
      paddingRight: theme.spacing(myTheme.padding.right + 3.4),
      marginBottom:30,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        //marginLeft:'15%'
      },
    },
    bCrumbLink: {
      "text-decoration": "none",
      "&:hover": {
        color: "black",
        "text-decoration": "none",
      },
    },
    imagecover: {
      width: '100%',
      height: 320,
      objectFit: 'cover',
      backgroundImage: `url('${aboutusImg}')`,
      backgroundRepeat: "no-repeat",
      backgroundColor:
        theme.palette.type === "light"
          ? theme.palette.grey[50]
          : theme.palette.grey[900],
      backgroundSize: "cover",
      backgroundPosition: "center",
      position: 'relative'
    },
    boxesOfAccount:{
      "&:hover": {
        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
      }
    },

    iconHover: {
      color: "grey",
      "&:hover": {
        color: '#EF233C'
      }
    },

    layer: {
      backgroundColor: "rgba(255, 0, 0, 0.4)",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%"
    },
    textImageContainer: {
      position: "absolute",
      top: "40%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },

    servicesBox: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(8),
      //paddingTop: theme.spacing(2)
      display: "flex",
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        justifyContent: "center",

        margin: "auto",
      },
      [theme.breakpoints.down(1030)]: {
        //paddingTop: theme.spacing(2),
        paddingRight: 0,
        margin: "auto",
        justifyContent: "center",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: 0,
        paddingRight: 0,
        //marginLeft:'15%'
      },
    },
    service: {
      display: "flex",
      marginRight: theme.spacing(7),
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        paddingTop: theme.spacing(2),
        marginRight: theme.spacing(0),
      },
      [theme.breakpoints.down(1310)]: {
        paddingTop: theme.spacing(2),
        // marginRight:theme.spacing(17),
        margin: "auto",
        justifyContent: "center",
      },
    },
    serviceIcon: {
      fontSize: "70px",
      color: myTheme.palette.primary.main,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        fontSize: "50px",
      },
    },
    serviceText: {
      fontWeight: "bold",
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(2),
    },
    serviceTextLight: {
      color: "grey",
      paddingLeft: theme.spacing(2),
      fontSize: 14,
      whiteSpace: "noWrap",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        //marginBottom: theme.spacing(5)
      },
    },
    servicesTextBox: {
      paddingLeft: 5,
      [theme.breakpoints.down(1310)]: {
        //paddingTop: theme.spacing(2),
        marginRight: theme.spacing(17),
        margin: "auto",
        justifyContent: "center",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        //paddingTop: theme.spacing(2),
        marginRight: theme.spacing(2),
        margin: "auto",
        justifyContent: "center",
        alignItems: "center",
      },
    },
  };
});

export default useStyles;